import { createSlice } from '@reduxjs/toolkit';

// Client state for the Internal jobs "Your applications" tab.
// Uses the new ("Filters" dropdown) filter framework — selected rows stored as `feConfig`.
const reducerName = 'internalApplications';
const initialState = {
  searchTerm: null,

  filters: {
    feConfig: [],
    isFilterApplied: false,
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Applied (Newest to oldest)',
    value: 'DESC',
    element: 'created_at',
    order: 'DESC',
  },
};

const { reducer, actions: internalApplicationsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    setFiltersData: (state, { payload }) => {
      state.filters.feConfig = payload || [];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters.feConfig = (state.filters.feConfig || []).filter(
        (row) => row?.filter_by?.value !== key
      );
      state.page = { ...initialState.page };
      state.filters.isFilterApplied =
        state.filters.feConfig.length > 0 || !!state.searchTerm;
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters, feConfig: [] };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = false;
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied =
        payload?.searchTerm?.length > 0 ||
        (state.filters.feConfig || []).length > 0;
    },
  },
});

export { internalApplicationsActions };
export default reducer;
